export default __webpack_public_path__ + "static/media/eu-funded-project.2d432d2a.svg";